import PropTypes from 'prop-types'
import { SupportedThirdPartyServices } from '../../models/common/supported-third-party-services'

/**
 * Proptype defining the rest model for third-party-services
 *
 * @typedef {Object} ThirdPartyService
 * @property {SupportedThirdPartyServices} applicationType    - The identifier for the service to be called.
 * @property {string} [errorRedirectUrl]                      - An url to call in case an error occurred when
 *                                                              calling the serviceUrl
 * @property {string} serviceName                             - The name of the service
 * @property {string} serviceUrl                              - The url to call the service
 * @property {boolean} [ssoEnabled]                           - Flag to indicate if the service can be called
 *                                                              using Single-Sign-On (SSO)
 * @property {string} [systemId]                              - An identifier for the software system that wants
 *                                                              to call the service
 */
export const thirdPartyServicePropType = PropTypes.shape({
    applicationType: PropTypes.oneOf(SupportedThirdPartyServices).isRequired,
    errorRedirectUrl: PropTypes.string,
    serviceName: PropTypes.string.isRequired,
    serviceUrl: PropTypes.string.isRequired,
    ssoEnabled: PropTypes.bool,
    systemId: PropTypes.string
})
